import { bindable, autoinject, computedFrom } from "aurelia-framework";
import { ServiceDataItemHandler } from "../services/measure-service";
import { AppSettings } from "../../../utils/appsettings";
import { AutocompleteItem } from "../../../components/autocomplete/autocomplete-service";
import { some } from "lodash";
import {
	DataItemSelectionResult,
	DataItemOption
} from "../../customers/reported-service-data-item-service";
import {
	AttachedDataItem,
	ReportedServiceDataItemType
} from "../../reported-service-data-items/reported-service-data-item-models";
import { ResourceService } from "../../../utils/resourceService";

@autoinject
export class MeasureAttach {
	@bindable
	serviceDataItems: AttachedDataItem[] = [];
	@bindable
	serviceId: string;
	@bindable
	adding = false;
	@bindable
	autocompleteHasFocus = false;
	@bindable
	availableDataItems: DataItemOption[];

	dataItemName: string;
	dataItem: DataItemSelectionResult = null;

	constructor(
		private measureHandler: ServiceDataItemHandler,
		private resourceService: ResourceService
	) {}

	@computedFrom("serviceDataItems")
	get listHasItems() {
		return this.serviceDataItems && this.serviceDataItems.length > 0;
	}

	get language() {
		return AppSettings.lang;
	}

	showAdd() {
		this.adding = true;
		this.autocompleteHasFocus = true;
	}

	cancel() {
		this.adding = false;
		this.reset();
	}

	itemSelected(item: AutocompleteItem) {
		if (!item) {
			this.dataItem = null;
			return;
		}

		this.dataItem = new DataItemSelectionResult({
			dataItemId: item.id,
			serviceId: this.serviceId,
			type: this.availableDataItems.find(i => i.id === item.id).type
		});
	}

	private async attachItem(dataItem: DataItemSelectionResult) {
		await this.measureHandler.attachDataItem(dataItem);
		this.adding = false;
		this.reset();
	}

	async add() {
		if (
			this.serviceDataItems &&
			this.serviceDataItems.some(
				m => m.dataItemId === this.dataItem.dataItemId
			)
		) {
			var confirmDuplicateAttach = this.resourceService.getResource(
				"MeasureAttachForm_Label_ConfirmDuplicateMeasure"
			);
			if (confirm(confirmDuplicateAttach)) {
				await this.attachItem(this.dataItem);
			}
		} else {
			await this.attachItem(this.dataItem);
		}
	}

	filterMeasure(item: AutocompleteItem) {
		return !some(
			this.serviceDataItems,
			m =>
				m.dataItemId === item.id &&
				m.type === ReportedServiceDataItemType.PerformanceIndicator
		);
	}

	reset() {
		this.dataItem = null;
		this.dataItemName = null;
	}
}
